import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { MenuItems } from "./settings";

const Menu = () => {
    const { pathname } = useLocation();

    const activeClass = "bg-gray-700 bg-opacity-20";
    const hoverClass = "hover:bg-gray-700 hover:bg-opacity-20";

    return (
        <ul className="h-full">
            {MenuItems.map((item, i) => (
                <li
                    key={i}
                    className={classNames(
                        "inline-flex items-center cursor-pointer transition-all duration-300 h-full",
                        item.checkActiveType === "equal"
                            ? pathname === item.route
                                ? activeClass
                                : hoverClass
                            : pathname.startsWith(item.route)
                            ? activeClass
                            : hoverClass,
                    )}>
                    <Link
                        to={item.route}
                        className="inline-flex items-center py-5 px-3 lg:px-5">
                        <item.Icon className="text-xl ml-2 hidden sm:inline-block" />
                        {item.text}
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default Menu;
